import { render, staticRenderFns } from "./ChooseSellers.vue?vue&type=template&id=0a5bba7f&scoped=true&"
import script from "./ChooseSellers.vue?vue&type=script&lang=js&"
export * from "./ChooseSellers.vue?vue&type=script&lang=js&"
import style0 from "./ChooseSellers.vue?vue&type=style&index=0&id=0a5bba7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5bba7f",
  null
  
)

export default component.exports